import React from 'react';

interface LineProps {
    addStyle?: string;
}

const Line: React.FC<LineProps> = ({ addStyle = "" }) => {
    return (
        <div 
            className={`border-t-0 border-l border-b-0 border-r-0 border-gray-200 ${addStyle}`} 
        ></div>
    );
}

export default Line;
